export default "/images/74916326a4b6f16866043d3c83484ed5.png";